<label class="custom-checkbox">
  <input type="checkbox" [checked]="checked" (change)="onChange($event)" />
  <span class="checkmark"></span>
  <ng-content></ng-content>
</label>
